<template>
  <Dialog :open="open" @update:open="$emit('update:open', $event)">
    <DialogContent class="sm:max-w-[600px] p-0 gap-0 flex flex-col max-h-[85vh] overflow-hidden">
      <DialogHeader class="px-6 pt-6 pb-4 border-b shrink-0">
        <slot name="header" />
      </DialogHeader>

      <!-- body: clip here so children can use flex-1 / overflow-y-auto freely -->
      <div class="flex-1 min-h-0 overflow-hidden flex flex-col">
        <slot />
      </div>

      <DialogFooter v-if="$slots.footer" class="shrink-0 px-6 py-4 border-t gap-3">
        <slot name="footer" />
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
} from '@/components/ui/dialog'

defineProps<{ open: boolean }>()
defineEmits<{ (e: 'update:open', val: boolean): void }>()
</script>
